'use es6';
/**
 * Creates action creator message functions for async actions.
 *
 * @param {String}      dataName
 * @param {ActionTypes} type
 */

export const createAsyncActions = (dataName, type) => ({
  request: () => ({
    type
  }),
  receive: data => ({
    type,
    [dataName]: data
  }),
  error: error => ({
    type,
    error
  })
});
const timestampForActionCache = new WeakMap();
/**
 * Gets and memoizes a timestamp for a message sent by an action creator.
 * This is so the timestamp is consistent for an action - reducers and middleware
 * responding to the same action won't fire at the same moment.
 *
 * @param {Object} actionMessage - Message sent by an action creator.
 * @returns {Number} timestamp
 */

export function getTimestampForAction(actionMessage) {
  const last = timestampForActionCache.get(actionMessage);
  if (last) return last;
  const ts = Date.now();
  timestampForActionCache.set(actionMessage, ts);
  return ts;
}